import React from 'react'


// Common Components
import Navbar from "../../common/navbar/mainnavbar";
import Footer from "../../common/footer/index";
import Header from "../../common/Header/header";
const PrivacyPolicy = () => {
    return (
        <>
            <Navbar />
            <div className="payment py-5">
                <div className='service-bg-color'>
                    <div className="pt-5">
                        <Header title="Rumeno" subtitle="Privacy Policy" />
                    </div>
                    <div className='container py-5'>
                        <div className='text-center'>
                            <p className='service-heading fw-bold'>Privacy Policy</p>

                            <div className='my-5'>
                                <p className='bg-white py-2 font-size-24 rounded  shadow'>Privacy Policy for Rumeno Farmotech</p>
                                <p className='heading-description pt-3'>At Rumeno Farmotech, accessible from https://www.rumeno.in/, one of our main priorities is the privacy of our visitors. This Privacy Policy document contains
                                    types of information that is collected and recorded by Rumeno Farmotech and how we use it.</p>
                                <p className='heading-description'>If you have additional questions or require more information about our Privacy Policy, do not hesitate to contact us.</p>
                            </div>

                            <div className='my-5'>
                                <p className='bg-white py-2 font-size-24 rounded  shadow'>Log Files</p>
                                <p className='heading-description pt-3'>Rumeno Farmotech follows a standard procedure of using log files. These files log visitors when they
                                    visit websites. All hosting companies do this and a part of hosting services' analytics. The information collected by log files include
                                    internet protocol (IP) addresses, browser type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly
                                    the number of clicks. These are not linked to any information that is personally identifiable. The purpose of the information is for
                                    analyzing trends, administering the site, tracking users' movement on the website, and gathering demographic information. Our Privacy
                                    Policy was created with the help of the Privacy Policy Generator.</p>
                            </div>

                            <div className='my-5'>
                                <p className='bg-white py-2 font-size-24 rounded  shadow'>Cookies and Web Beacons</p>
                                <p className='heading-description pt-3'>
                                    Like any other website, Rumeno Farmotech uses "cookies". These cookies are used to store information including visitors' preferences,
                                    and the pages on the website that the visitor accessed or visited. The information is used to optimize the users' experience by
                                    customizing our web page content based on visitors' browser type and/or other information.</p>
                            </div>

                            <div className='my-5'>
                                <p className='bg-white py-2 font-size-24 rounded  shadow'>Privacy Policies</p>
                                <p className='heading-description pt-3'>
                                    You may consult this list to find the Privacy Policy for each of the advertising partners of Rumeno Farmotech.</p>
                                <p className='heading-description'>
                                    Third-party ad servers or ad networks uses technologies like cookies, JavaScript, or Web Beacons that are used in their respective advertisements and links that
                                    appear on Rumeno Farmotech, which are sent directly to users' browser. They automatically receive your IP address when this occurs.
                                    These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the advertising content that
                                    you see on websites that you visit.</p>
                                <p className='heading-description'>Note that Rumeno Farmotech has no access to or control over these cookies that are used by third-party advertisers.</p>
                            </div>

                            <div className='my-5'>
                                <p className='bg-white py-2 font-size-24 rounded  shadow'>Third Party Privacy Policies</p>
                                <p className='heading-description pt-3'>Rumeno Farmotech's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt-out of certain options.</p>
                                <p className='heading-description'>You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with specific web browsers, it can be found at the browsers' respective websites.</p>
                            </div>

                            <div className='my-5'>
                                <p className='bg-white py-2 font-size-24 rounded  shadow'>Children's Information</p>
                                <p className='heading-description pt-3'>Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe, participate in, and/or monitor and guide their online activity.</p>
                                <p className='heading-description'>
                                    Rumeno Farmotech does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child provided this kind of information on our website, we strongly encourage you to contact us
                                    immediately and we will do our best efforts to promptly remove such information from our records.</p>
                            </div>

                            <div className='my-5'>
                                <p className='bg-white py-2 font-size-24 rounded  shadow'>Consent</p>
                                <p className='heading-description pt-3'>By using our website, you hereby consent to our Privacy Policy and agree to its Terms and Conditions.</p>
                            </div>

                            <hr />
                            {/* <p className='bg-white py-2 font-size-24 rounded shadow mt-5'></p> */}
                            <p className='service-heading fw-bold mb-5'>Return Policy for Animal Feed Supplements</p>
                            <div className='my-4 text-start'>
                                <p className='bg-white py-2 font-size-24 rounded shadow text-start ps-5'>1. Eligibility for Returns
                                </p>
                                <p className='heading-description pt-3 text-start'>We want you to be satisfied with your purchase. If you are not completely happy with your animal feed supplement, here are the eligibility criteria for returns:</p>
                                <ul>
                                    <li><span className='fw-bold'>Unopened Products :</span> You may return unopened animal feed supplements within 15 days of the purchase date.
                                    </li>
                                    <li><span className='fw-bold'>Defective or Damaged Products :</span> If you receive a product that is defective or damaged, please contact us within 7 days of delivery.
                                    </li>
                                </ul>
                            </div>

                            <div className='my-4 text-start'>
                                <p className='bg-white py-2 font-size-24 rounded shadow text-start ps-5'>2. How to Initiate a Return
                                </p>
                                <p className='heading-description pt-3 text-start'>To initiate a return, follow these steps:</p>
                                <ul>
                                    <li><span className='fw-bold'>Contact Us:</span> Reach out to our customer support team via email support@rumenofarmotech.com or Whats app message on phone # 7355043892. Provide your order number and a brief description of the issue
                                    </li>
                                    <li><span className='fw-bold'>Return Authorization:</span> We will provide you with a return authorization (RA) number.
                                    </li>
                                    <li><span className='fw-bold'>Packaging:</span> Repackage the product securely, including all original packaging materials.
                                    </li>
                                    <li><span className='fw-bold'>Shipping:</span> Ship the product back to us using a trackable shipping method. You are responsible for return shipping costs.
                                    </li>
                                </ul>
                            </div>

                            <div className='my-4 text-start'>
                                <p className='bg-white py-2 font-size-24 rounded shadow text-start ps-5'>3. Refund Process
                                </p>
                                <ul className='py-2'>
                                    <li>Once we receive the returned product, we will inspect it.</li>
                                    <li>If the product meets the eligibility criteria, we will process your refund within 5 business days.</li>
                                    <li>Refunds will be issued to the original payment method used during the purchase.</li>
                                </ul>
                            </div>


                            <div className='my-4 text-start'>
                                <p className='bg-white py-2 font-size-24 rounded shadow text-start ps-5'>4. Exceptions</p>
                                <ul className='py-2'>
                                    <li><span className='fw-bold'>Opened Products:</span> Unfortunately, we cannot accept returns for opened or partially used products due to safety and hygiene reasons.
                                    </li>
                                    <li><span className='fw-bold'>Custom Orders:</span> Customized or personalized animal feed supplements are non-returnable unless they are defective.</li>
                                </ul>
                            </div>

                            <div className='my-4 text-start'>
                                <p className='bg-white py-2 font-size-24 rounded shadow text-start ps-5'>5. Contact Us</p>
                                <p className='heading-description pt-3 text-start'>If you have any questions or need assistance with your return, please contact our customer support team at support@rumenofarmotech.com or whats app us on 7355043892</p>
                            </div>

                        </div>






                    </div>
                </div>
            </div>


            <Footer />
        </>
    )
}

export default PrivacyPolicy;